import React, { useEffect, useState } from "react";
import Filter from "../filter";
import "./search.css";
import Button from "../button";
import MultiDatePicker from 'react-multi-date-picker';
import Select from "react-select";
import {
  getCountry,
  getLanguages,
  getTimezones,
} from "../../services/uidata";
import {
  capatilizeLetter,
  filterVisibleTimeZones,
  screenNameHandler,
} from "../../utils/helpers";
import FilterOperator from "../filterOperator";
import FilterOptions from "../filterOption";
import { setCountryArray } from "../../reducer/uidataSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

// Preset options for the Payment method filter (Transactions / Refunded tables).
const PAYMENT_METHOD_OPTIONS = ["stripe", "paypal", "SquareUp", "Pay it Forward"];

export default function Search({ callApi,callNewApi, list, setFilterValues,
  setSearchValues, searchValue, filterValues, isDatepickerShow,oneDayAdded=0, isOperator = 0, setFilterOprater, showOprater,
  setShowOprater, filterOprater, operatorList, setOperatorList, optionsList, setOptionsList, filterValueOptions,
  setFilterValueOptions, isAppointment,isSearchBtn=0, setServiceTypeShow, zoomFilter, setZoomFilter= () => { },
  serviceTypeShow = false, setFilterName = () => { } ,serviceTypeList = [],
  serviceFilterValue = "",
  filterOptions = {},
  setIsFilterDirty = () => {}, changeHandlerFilter = () => {}, }) {
  const { t } = useTranslation("components");
  const [inputValue, setInputValue] = useState(searchValue !== null && searchValue !== undefined ? Object.values(searchValue)[0] : '');
  const [timer, setTimer] = useState(null);
  const [filterValue, setFilterValue] = useState(filterValues == undefined ? '' : filterValues);


  const [values, setValues] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [filterValueOprater, setFilterValueOprater] = useState("=");

  const [countryData, setCountryData] = useState([]);
  const [TimezoneData, setTimezoneData] = useState([]);
  const [formLanguages, setFormLanguages] = useState([]);


  const dispatch = useDispatch();

  useEffect(() => {
    console.log(isOperator, "isOperator");
   // updateTimeZone();
    //updateCountries();
    //updateLanguage();
    // console.log(filterValues,"filterValues");
    // setFilterOprater(filterValueOprater)
    console.log(operatorList, "filterValues", filterValues, searchValue,"searchValue");
    if (searchValue && (searchValue.created_at || searchValue.session_date)) {
      let dates;
      if(searchValue.created_at){
         dates = searchValue.created_at.split(","); 
      }
      if(searchValue.session_date){ 
        dates = searchValue.session_date.split(",");  
      }
    

    const start = dates[0] ? new Date(dates[0]) : null;
    const end = dates[1] ? new Date(dates[1]) : null;

    setValues([start, end]);
  }else{
    if(isAppointment ==1){
        setShowOprater(false)
    }
  
  }
  }, []);
  const updateCountries = () => {
    getCountry()
      .then((data) => {
        setCountryData(data.data.data);
        dispatch(setCountryArray(data.data.data));
        const formattedCountryData = data.data.data.map(country => ({
          value: isAppointment === 1 ? country.id : country.country_name,
          name: country.country_name
        }));
         setOptionsList(formattedCountryData)

      })
      .catch((err) => console.log(err));

  };
  const updateTimeZone = () => {
    getTimezones()
      .then((data) => {
        if (data.data.status) {
          setTimezoneData(filterVisibleTimeZones(data.data.data));
        setOptionsList(formattedTimezoneData)
          const formattedTimezoneData = filterVisibleTimeZones(data.data.data).map(timezone => ({
            value: timezone.id,
            name: timezone.front_name
          }));
          setOptionsList(formattedTimezoneData)
        }
      })
      .catch((err) => console.log(err));
  };
  const updateLanguage = () => {
    getLanguages()
      .then((data) => {
        const languages = data.data.data.map(item => ({
            ...item,
            value: item.id,
            label: item.name,
          }));
        setFormLanguages(languages);
         const formattedformLanguages = languages.map(language => ({
          value: language.id,
          name: language.name
        }));
        setOptionsList(formattedformLanguages)
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {

    // console.log(searchValue, "searchValueGet")
    // console.log(values, "values")
    setInputValue(searchValue !== null && searchValue !== undefined && searchValue !== "" ? Object.values(searchValue)[0] : '');
  //   setValues(searchValue !== null && searchValue !== undefined && searchValue !== "" ? values : '');
  //   if (searchValue && searchValue.created_at) {
  //   const dates = searchValue.created_at.split(",");  

  //   const start = dates[0] ? new Date(dates[0]) : null;
  //   const end = dates[1] ? new Date(dates[1]) : null;

  //   setValues([start, end]);
  // }
  }, [searchValue])
  // useEffect(() => {
  //   // console.log(searchValue, "searchValue");
  //   setInputValue('');

  // }, [])
  const getValue = (obj) => {
    // Object.values(obj)[0];
    return obj !== null && obj !== undefined ? Object.values(obj)[0] : ''
  }
  const inputChanged = (e) => {
    setInputValue(e.target.value);

    let name = {};
    // if(isOperator ==1){
    //   setFilterOprater(filterValueOprater)
    // }
    if (filterValues === "") {
      name["screen_name"] = e.target.value;
    } else {
      name[filterValues] = e.target.value;
    }

    clearTimeout(timer);
    setSearchValues(name);
    setSearchVal(name);
    let oprateVal = filterOprater;
    const newTimer = setTimeout(() => {
      if (e.target.value.length > 2 || e.target.value.length === 0) {
        callApi(name, oprateVal);
      }
    }, 2000);

    setTimer(newTimer);
  };
  // Dropdown-based filters (e.g. Payment method) fire immediately, no debounce.
  const selectFilterChanged = (e) => {
    setInputValue(e.target.value);
    let name = {};
    name[filterValues === "" ? "screen_name" : filterValues] = e.target.value;
    clearTimeout(timer);
    setSearchValues(name);
    setSearchVal(name);
    callApi(name, filterOprater);
  };
  const changeHandler = (e) => {
    if (setFilterValueOptions !== undefined) {
      setFilterValueOptions("")

      if (isAppointment == 1) {
        setServiceTypeShow(true)
      }
      let filterVal = e.target.value;
      const configuredOptions = filterOptions[filterVal];
      setFilterName(filterVal);
      if (configuredOptions) {
        setZoomFilter(false);
        setOperatorList(["="]);
        setFilterValueOprater("=");
        setFilterOprater("=");
        setShowOprater(false);
        setOptionsList(configuredOptions);
      } else if (filterVal == "screen_name" || filterVal == "legal_name" || filterVal == "email" || filterVal == "session_type" || filterVal == "name" || filterVal == "medium_email" || filterVal == "client_email" || filterVal == "extra_tags") {
        setZoomFilter(false)
        if(filterVal != "extra_tags"){
           setOperatorList(['=', 'LIKE']);
        }else{
           setOperatorList(['LIKE']);
        }
       
        setFilterValueOprater("LIKE");
        setFilterOprater("LIKE");
        if (isOperator == 1) {
          setShowOprater(true);
        }
        if (isAppointment == 1) {
          setShowOprater(false);
        }
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
        if (filterVal == "session_type" && isAppointment == 1) {
          setServiceTypeShow(true)
        }
      } else if (filterVal == "id" || filterVal == "meeting_id") {
        setZoomFilter(false)
        setOperatorList(['=']);
        setFilterValueOprater("=");
        setFilterOprater("=");
        if (isOperator == 1) {
          setShowOprater(true)
        }
        if (isAppointment == 1) {
          setShowOprater(false);
        }
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
      } else if (filterVal == "phone" || filterVal == "whatsapp") {
        setZoomFilter(false)
        setOperatorList(['=', 'LIKE']);
        setFilterValueOprater("LIKE");
        setFilterOprater("LIKE");
        if (isOperator == 1) {
          setShowOprater(true)
        }
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
      } else if (filterVal == "created_at") {
        setZoomFilter(false)
        setOperatorList(['=', 'BETWEEN']);
        setFilterValueOprater("=");
        setFilterOprater("=");
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
        if (isOperator == 1) {
          setShowOprater(true)
        }
      } else if (filterVal == "session_date") {
        setZoomFilter(false)
        setOperatorList(['=', 'BETWEEN']);
        setFilterValueOprater("=");
        setFilterOprater("=");
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
        if (isOperator == 1) {
          setShowOprater(true)
        }
      } else if (filterVal == "country") {
        setZoomFilter(false)
        updateCountries();
        
        setFilterValueOprater("=");
        setFilterOprater("=");
       
        if (isOperator == 1) {
          setShowOprater(false)
        }
      } else if (filterVal == "language") {
        setZoomFilter(false)
        updateLanguage();
       
        if (isOperator == 1) {
          setShowOprater(false)
        }
      } else if (filterVal == "timezone") {
        setZoomFilter(false)
        setFilterValueOprater("=");
        setFilterOprater("=");
        updateTimeZone();
        
        if (isOperator == 1) {
          setShowOprater(false)
        }
      }
      else if (filterVal == "free_zoom_session") {
        console.log(filterVal, "filterVal")
        setZoomFilter(true)
        setShowOprater(false)
        let name = {

          orderBy: 'asc',
          oprater: "=",
          field: 'free_zoom_session',
          value: 1,
        }
        callApi(name,);
      }
      else if (filterVal == "referralCode") {
        setZoomFilter(false)
        setOperatorList(['=','LIKE']);
        setFilterValueOprater("=");
        setFilterOprater("=");
        if (isOperator == 1) {
          setShowOprater(true)
        }
        if (isAppointment == 1) {
          setShowOprater(false);
        }
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
      }
      else {
        setZoomFilter(false)
        setFilterValueOprater("=");
        setFilterOprater("=");
        if (isOperator == 1) {
          setShowOprater(false)
        }
        setOptionsList([{ value: '1', name: t("search.yes") },
        { value: '0', name: t("search.no") }]);
      }
    }
    setSearchVal("");
    setSearchValues("");
    console.log(e.target.value)
    setFilterValue(e.target.value);
    // setInputValue("");
    setFilterValues(e.target.value);
  };
  const changeHandlerOprater = (e) => {
    setFilterValueOprater(e.target.value);
    setFilterOprater(e.target.value);
  };
  const handleValueChange = (newValues) => {
    // This function will be called when the date picker's value changes
    if (isOperator == 1) {
      setFilterOprater(filterValueOprater)
    }
    if (newValues) {
      setValues(newValues);
      let name = {};
      if (newValues.length === 2) {
        const startDate = newValues[0].format("YYYY-MM-DD");
        const endDate = newValues[1].format("YYYY-MM-DD");
        name[filterValue] = `${startDate},${endDate}`; // Fix the assignment
      } else {
        const startDate = newValues[0].format("YYYY-MM-DD");
        name[filterValue] = `${startDate}`; // Fix the assignment
      }
      clearTimeout(timer);
      setSearchValues(name);
      setSearchVal(name);
      const newTimer = setTimeout(() => {
        let oprateVal = ""
        if (filterValueOprater == "BETWEEN") {
          oprateVal = "BETWEEN";
        } else {
          oprateVal = "LIKE";
        }
        if (isAppointment == 1) {
          callApi(name, "", "", oprateVal);
        } else {
          callApi(name, oprateVal);
        }

      }, 2000);
      setTimer(newTimer);
    }
  };
  const changeHandlerOptions = (e) => {
    const selectedValue = e.target.value;
    setValues(selectedValue);
    setFilterValueOptions(selectedValue);
    setFilterOprater("=");

    let name = {};
    name[filterValues] = selectedValue;

    if (timer) {
      clearTimeout(timer);
    }
    console.log("name", name)
setSearchVal((prevState) => {
      console.log("Previous State:", prevState); // Logs the previous state before the update
      return name;
    });
    setSearchValues((prevState) => {
      console.log("Previous State:", prevState); // Logs the previous state before the update
      return name;
    });



    const newTimer = setTimeout(() => {
      callApi(name, "=");
    }, 2000);

    setTimer(newTimer);
  };

  const LoadData = () => {
  
    // if(searchVal==""){
    //   return;
    // }
     let name = {};
    // if(isOperator ==1){
    //   setFilterOprater(filterValueOprater)
    // }
    if (filterValues === "") {
      name["screen_name"] = inputValue;
    } else {
      name[filterValues] = inputValue;
    }
    callNewApi(name, "", "", filterValueOprater);
  console.log(name, "searchValLoad", filterValueOprater);
}
 const LoadDataApt = () => {

    // if(searchVal=="" && serviceFilterValue==""){
    //   return;
    // }
    callNewApi(searchVal, "", "", filterValueOprater);
  console.log(searchVal, "searchValLoad", filterValueOprater);
}
  return (
    <div className="filter-wrapper">
      {isOperator == 1 && <><span className="selectOption"> 
        {/* Filter By: */}
        </span><Filter list={list} changeHandler={changeHandler} filterValue={filterValues} name={t("search.filterBy")} /> {showOprater && <><span className="selectOption"> {/*Operator: */}</span>< FilterOperator operatorList={operatorList} changeHandlerOprater={changeHandlerOprater} filterOprater={filterOprater} name={'operator'} /></>} </>}
      {isDatepickerShow && isDatepickerShow === 1 ? (
        (filterValues === "created_at" || (filterValues === "session_date" && filterOprater == "BETWEEN")) ? (

          <MultiDatePicker
            style={{ height: "45px" }}
            className="search-input"
            value={values}
            onChange={handleValueChange}
            range
            placeholder={t("search.selectDateRange")}
             maxDate={ filterValues !== "session_date"
    ? (
        oneDayAdded === 1
          ? new Date(new Date().setDate(new Date().getDate() + 1))
          : new Date()
      )
    : null
              }
          />
        ) : (
          <div className="search-box search-container">
            {((isOperator == 1 && showOprater) || (isAppointment == 1 && !showOprater)) && ((filterValues === "id" ||
              filterValues === "email" ||
              filterValues === "referralCode" ||
              filterValues === "screen_name" ||
              filterValues === "extra_tags" ||
              filterValues === "phone" ||
              filterValues === "whatsapp" ||
              filterValues === "session_type" ||
              filterValues === "name" ||
              filterValues === "medium_email" ||
              filterValues === "client_email" ||
              filterValues === "meeting_id" ||
              filterValues === "session_date" ||
              filterValues === "legal_name")) ? (

              <input
                value={inputValue}
                onChange={inputChanged}
                className="search-input"
                type={(filterValues === "created_at" || (filterValues === "session_date" && filterOprater != "BETWEEN")) ? "date" : "text"}
                placeholder={t("search.search")}
              />

            ) : (
              showOprater === false && !zoomFilter && (
                <FilterOptions
                  optionsList={optionsList}
                  filterValueOptions={filterValueOptions}
                  changeHandlerOptions={changeHandlerOptions}
                  name={t("search.selectOption")}
                />
              )
            )}

            {isOperator == 0 &&
              <input
                value={inputValue}
                onChange={inputChanged}
                className="search-input"
                type={(filterValues === "created_at" || filterValues === "session_date") ? "date" : "text"}
                placeholder={t("search.search")}
              />}
          </div>
        )
      ) : (
        <div className="search-box search-container">
          {filterValues === "payment_method" ? (
            <select
              value={inputValue}
              onChange={selectFilterChanged}
              className="search-input pointer cl-pont"
            >
              <option value="">{t("search.allPaymentMethods")}</option>
              {PAYMENT_METHOD_OPTIONS.map((method) => (
                <option key={method} value={method}>
                  {method === "SquareUp" ? "Square" : method === "stripe" ? "Stripe" : method === "paypal" ? "PayPal" : method === "Pay it Forward" ? t("search.payItForward") : method}
                </option>
              ))}
            </select>
          ) : (
            <input
              value={inputValue}
              onChange={inputChanged}
              className="search-input"
              type={(filterValues === "created_at" || filterValues === "session_date") ? "date" : "text"}
              placeholder={t("search.search")}
            />
          )}
        </div>
      )}
      {isAppointment == 1  && isSearchBtn == 1  &&
      <>
        <Select
                id="serviceType"
      
                name={'Service Type'}
                className="selection-box"
                options={serviceTypeList}
                multi={true}
                isMulti
                onChange={(value) => (changeHandlerFilter(value, 'upcoming'), setIsFilterDirty(false))}
                placeholder={t("search.serviceType")}
                value={serviceFilterValue}
                isClearable={true}
                closeMenuOnSelect={false}
                closeMenuOnScroll={false}
                /* Fix overlap: render the menu in a portal above the table instead of inline */
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({
                    ...base,
                    marginTop: 0,
                    top: "100%",
                    transform: "none",
                  }),
                }}
              />
       <Button
                status={0}
                type="button"
                onClick={LoadDataApt}
           
                className={`resend-btn width-100px reset-btn-123`}
                title={t("search.search")}
              />
              </>
      }
      {isAppointment != 1  && isSearchBtn == 1  &&
       <Button
                status={0}
                type="button"
                onClick={LoadData}
           
                className={`resend-btn width-100px reset-btn-123`}
                title={t("search.search")}
              />
              
      }

      {isOperator == 0 && <Filter list={list} changeHandler={changeHandler} filterValue={filterValues} name={t("search.filterBy")} />}
    </div>
  );
}
